import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.report');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-report',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.report/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #202733;
  background: #f4f6f9;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
}

.report-shell {
  min-height: 100vh;
}

.report-header {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d9dee7;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

.report-header__inner {
  width: min(1220px, 100% - 32px);
  min-height: 60px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.report-brand {
  color: #14532d;
  font-size: 18px;
  font-weight: 850;
  letter-spacing: 0;
  text-decoration: none;
}

.report-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.report-nav a {
  padding: 7px 10px;
  border-radius: 6px;
  color: #475467;
  font-size: 13px;
  font-weight: 750;
  text-decoration: none;
}

.report-nav a:hover,
.report-nav a:focus-visible {
  color: #166534;
  background: #e8f5ed;
  outline: none;
}

.report-page {
  width: min(1220px, 100% - 32px);
  margin: 0 auto;
  padding: 22px 0 44px;
  display: grid;
  grid-template-columns: 210px minmax(0, 1fr) 230px;
  gap: 18px;
  align-items: start;
}

.report-toc,
.report-side,
.report-article {
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.report-toc,
.report-side {
  position: sticky;
  top: 82px;
  padding: 14px;
}

.report-toc h2,
.report-side h2 {
  margin: 0 0 10px;
  color: #111827;
  font-size: 15px;
  letter-spacing: 0;
}

.report-toc ol,
.report-side ul {
  margin: 0;
  padding-left: 18px;
  color: #475467;
  font-size: 12px;
  line-height: 1.75;
}

.report-toc a {
  color: #475467;
  text-decoration: none;
}

.report-toc a:hover,
.report-toc a:focus-visible {
  color: #166534;
  text-decoration: underline;
  outline: none;
}

.report-article {
  min-width: 0;
  overflow: hidden;
}

.report-hero {
  padding: 30px;
  border-bottom: 1px solid #e4e8ef;
  background: #ffffff;
}

.report-eyebrow {
  margin: 0 0 8px;
  color: #15803d;
  font-size: 12px;
  font-weight: 850;
}

.report-hero h1 {
  margin: 0;
  color: #111827;
  font-size: 34px;
  line-height: 1.25;
  letter-spacing: 0;
}

.report-lead {
  max-width: 780px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 15px;
  line-height: 1.75;
}

.report-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.report-meta span {
  padding: 6px 9px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #344054;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 750;
}

.report-section {
  padding: 24px 30px;
  border-bottom: 1px solid #e4e8ef;
}

.report-section:last-child {
  border-bottom: 0;
}

.report-section h2 {
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9dee7;
  color: #111827;
  font-size: 23px;
  line-height: 1.35;
  letter-spacing: 0;
}

.report-section h2 span {
  margin-right: 8px;
  color: #15803d;
}

.report-section p {
  margin: 0 0 12px;
  color: #344054;
  font-size: 14px;
  line-height: 1.75;
}

.summary-grid,
.directive-grid,
.check-grid {
  display: grid;
  gap: 12px;
}

.summary-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 16px;
}

.directive-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.check-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.summary-card,
.directive-card,
.check-item,
.screen-item,
.content-taxonomy > div {
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.summary-card,
.directive-card,
.check-item,
.screen-item,
.content-taxonomy > div {
  padding: 14px 16px;
}

.summary-card h3,
.directive-card h3,
.content-taxonomy h3 {
  margin: 0 0 8px;
  color: #172033;
  font-size: 15px;
  letter-spacing: 0;
}

.summary-card p,
.check-item p,
.screen-item p {
  margin: 0;
  font-size: 13px;
}

.report-table {
  width: 100%;
  margin: 12px 0 0;
  border-collapse: collapse;
  border: 1px solid #d9dee7;
  font-size: 13px;
}

.report-table th,
.report-table td {
  padding: 11px 12px;
  border: 1px solid #d9dee7;
  text-align: left;
  vertical-align: top;
}

.report-table th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
}

.report-table td {
  color: #475467;
  background: #ffffff;
}

.screen-list {
  display: grid;
  gap: 10px;
}

.screen-item strong,
.check-item strong {
  display: block;
  margin-bottom: 6px;
  color: #14532d;
  font-size: 13px;
}

.content-taxonomy {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.content-taxonomy ul,
.directive-card ul {
  margin: 0;
  padding-left: 18px;
  color: #344054;
  font-size: 13px;
  line-height: 1.75;
}

.copy-block {
  margin: 12px 0 0;
  padding: 16px;
  overflow-x: auto;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #111827;
  color: #e5e7eb;
  font-size: 13px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.report-side ul {
  margin-bottom: 12px;
}

.side-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  margin-top: 8px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #166534;
  background: #ffffff;
  font-size: 12px;
  font-weight: 800;
  text-decoration: none;
}

.side-link:hover,
.side-link:focus-visible {
  background: #f0fdf4;
  outline: none;
}

@media (max-width: 1080px) {
  .report-page {
    grid-template-columns: 1fr 230px;
  }
  .report-toc {
    position: static;
    grid-column: 1/-1;
  }
  .summary-grid,
  .directive-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 820px) {
  .report-header__inner,
  .report-page {
    width: min(100% - 24px, 1220px);
  }
  .report-header__inner {
    min-height: auto;
    padding: 12px 0;
    align-items: flex-start;
    flex-direction: column;
  }
  .report-page,
  .content-taxonomy,
  .check-grid {
    grid-template-columns: 1fr;
  }
  .report-side {
    position: static;
    order: -1;
  }
  .report-hero,
  .report-section {
    padding-left: 18px;
    padding-right: 18px;
  }
  .report-hero h1 {
    font-size: 28px;
  }
}`],
})
export class PageReportComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }
}

export default PageReportComponent;